import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import { RemoteApiError } from "../useRemote/types";

interface RequestType {
  ids: number[];
}

export function useRemoteDeleteEquipment() {
  return useRemoteMutation<void, RemoteApiError, RequestType>({
    key: ["delete-equipment"],
    url: "/equipment-inventory/delete",
    method: "post",
    snackbarTextFunOnFail: error => `${(error as any).response.data.message}`
  });
}
